import type { Node } from '@craftjs/core';
import {
  FormSelectionField as SharedFormSelectionField,
  type FormSelectionFieldProps,
  formSelectionFieldDefaultProps,
} from '@builder4/shared/components/Form';
import { FORM_SELECTION_FIELD_NODE_NAME } from '@/utils/constants';
import { InspectorForm } from '@/components/inspector/InspectorForm/InspectorForm';

type NodeQueryHelper = (id: string) => {
  get(): Node | null;
  childNodes(): string[];
};

const EditorFormSelectionField = (props: Partial<FormSelectionFieldProps>) => {
  return <SharedFormSelectionField {...props} />;
};

EditorFormSelectionField.craft = {
  ...SharedFormSelectionField.craft,
  displayName: FORM_SELECTION_FIELD_NODE_NAME,
  props: formSelectionFieldDefaultProps,
  related: {
    toolbar: InspectorForm,
  },
  rules: {
    canDrag: (node: Node, helpers: NodeQueryHelper) => {
      if (node.data.custom?.isLocked) return false;

      // Allow dragging selection fields
      const parentId = node.data.parent;
      if (!parentId) return false;
      const parent = helpers(parentId).get();
      if (!parent) return false;

      // Check if there are other fields in the form
      const siblingFieldIds = parent.data.nodes.filter((childId: string) => {
        const child = helpers(childId).get();
        return child?.data.displayName === FORM_SELECTION_FIELD_NODE_NAME;
      });

      // Allow dragging if there's more than one selection field (form can have 0 selection fields)
      return siblingFieldIds.length > 1;
    },
    canMoveOut: () => {
      // Selection fields can be moved out (not required minimum)
      return true;
    },
    canMoveIn: () => false, // Fields cannot accept children
  },
};

export default EditorFormSelectionField;
